import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";

const useStyles = createUseStyles({
  // Main layout styles
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  
  batteryHealthRoot: {
    padding: "30px clamp(16px, 3vw, 30px)",
    overflowY: "auto",
    height: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },

  // Header styles
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    padding: "0px",
  },

  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },

  backButton: {
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    color: colors.primary,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      backgroundColor: colors.primaryLight,
      color: colors.white,
    },
    transition: "all 0.3s ease-in-out",
  },

  periodSelector: {
    backgroundColor: colors.surface,
    borderRadius: "8px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
    
    "& .MuiButton-root": {
      fontWeight: "500",
      textTransform: "none",
      padding: "8px 16px",
    },
  },

  activePeriod: {
    backgroundColor: colors.primary,
    color: colors.white,
    "&:hover": {
      backgroundColor: colors.primaryDark,
    },
  },

  inactivePeriod: {
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    color: colors.textSecondary,
    borderColor: colors.borderLight,
    "&:hover": {
      backgroundColor: colors.primaryLight,
      borderColor: colors.primary,
    },
  },

  // Vehicle info card styles
  vehicleInfoCard: {
    padding: "24px",
    marginBottom: "24px",
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    background: "linear-gradient(135deg, var(--c-surface-2) 0%, var(--c-surface) 100%)",
    border: `1px solid ${colors.borderLight}`,
  },

  vehicleInfoContent: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "16px",
  },

  vehicleAvatar: {
    width: "64px",
    height: "64px",
    backgroundColor: colors.primary,
    background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
  },

  vehicleDetails: {
    flex: 1,
  },

  vehicleName: {
    fontWeight: "700",
    color: colors.textPrimary,
    marginBottom: "8px",
  },

  vehicleMetadata: {
    color: colors.textSecondary,
    fontWeight: "500",
  },

  stateOfCharge: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    paddingTop: "16px",
    borderTop: `1px solid ${colors.borderLight}`,
  },

  stateOfChargeLabel: {
    color: colors.textSecondary,
    fontWeight: "500",
  },

  stateOfChargeValue: {
    fontWeight: "600",
    color: colors.textPrimary,
  },

  // Grid styles
  mainStatsGrid: {
    marginBottom: "32px",
  },

  detailedScoresGrid: {
    marginBottom: "32px",
  },

  additionalStatsGrid: {
    marginBottom: "32px",
  },

  // Main card styles
  mainCard: {
    height: "100%",
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    background: "linear-gradient(135deg, var(--c-surface-2) 0%, var(--c-surface) 100%)",
    border: `1px solid ${colors.borderLight}`,
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  mainCardContent: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },

  mainCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
  },

  mainCardIcon: {
    color: colors.primary,
    fontSize: "24px",
  },

  mainCardTitle: {
    flex: 1,
    fontWeight: "600",
    color: colors.textPrimary,
  },

  infoButton: {
    color: colors.textSecondary,
    "&:hover": {
      backgroundColor: colors.primaryLight,
      color: colors.primary,
    },
  },

  mainScoreContent: {
    textAlign: "center",
    padding: "20px 0",
  },

  mainScore: {
    color: colors.primary,
    fontWeight: "bold",
    marginBottom: "8px",
    background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  gradeText: {
    color: colors.textSecondary,
    marginBottom: "16px",
    fontWeight: "500",
  },

  healthStatusChip: {
    textTransform: "capitalize",
    fontWeight: "600",
    padding: "4px 12px",
  },

  // Score card styles
  scoreCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    background: "linear-gradient(135deg, var(--c-surface-2) 0%, var(--c-surface) 100%)",
    border: `1px solid ${colors.borderLight}`,
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  scoreCardContent: {
    flexGrow: 1,
    padding: "20px",
  },

  scoreCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
  },

  scoreCardTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  scoreCardIcon: {
    fontSize: "20px",
  },

  scoreCardTitle: {
    fontSize: "0.9rem",
    fontWeight: "600",
    color: colors.textPrimary,
  },

  scoreChip: {
    fontWeight: "600",
  },

  progressSection: {
    marginBottom: "16px",
  },

  markText: {
    color: colors.textSecondary,
    marginBottom: "8px",
    fontWeight: "500",
  },

  progressBar: {
    height: "6px",
    borderRadius: "3px",
    backgroundColor: colors.borderLight,
  },

  descriptionText: {
    color: colors.textSecondary,
    marginBottom: "16px",
    lineHeight: "1.5",
  },

  recommendationBox: {
    padding: "12px 16px",
    backgroundColor: colors.primaryLight,
    border: `1px solid ${colors.primary}`,
    borderRadius: "8px",
    background: "linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)",
  },

  recommendationText: {
    color: colors.primary,
    fontWeight: "500",
    lineHeight: "1.4",
  },

  // No data card styles
  noDataScoreCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    background: "linear-gradient(135deg, var(--c-surface-2) 0%, var(--c-surface) 100%)",
    border: `1px solid ${colors.borderLight}`,
  },

  noDataScoreCardContent: {
    flexGrow: 1,
    padding: "20px",
  },

  noDataScoreCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
  },

  noDataContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    minHeight: "120px",
  },

  noDataIcon: {
    fontSize: "48px",
    color: colors.textDisabled,
    marginBottom: "8px",
  },

  noDataText: {
    color: colors.textSecondary,
    fontWeight: "500",
  },

  // Stats card styles
  statsCard: {
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    background: "linear-gradient(135deg, var(--c-surface-2) 0%, var(--c-surface) 100%)",
    border: `1px solid ${colors.borderLight}`,
    transition: "all 0.3s ease-in-out",
    "&:hover": {
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
      transform: "translateY(-2px)",
    },
  },

  statsCardContent: {
    padding: "24px",
  },

  statsCardTitle: {
    fontWeight: "600",
    color: colors.textPrimary,
    marginBottom: "20px",
  },

  statsStack: {
    gap: "16px",
  },

  statRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    borderBottom: `1px solid ${colors.borderLight}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },

  statRowWithChip: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    borderBottom: `1px solid ${colors.borderLight}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },

  statLabel: {
    color: colors.textSecondary,
    fontWeight: "500",
  },

  statValue: {
    fontWeight: "600",
    color: colors.textPrimary,
  },

  statValueSuccess: {
    fontWeight: "600",
    color: colors.success,
  },

  statValueWarning: {
    fontWeight: "600",
    color: colors.warning,
  },

  statValueCapitalized: {
    fontWeight: "600",
    color: colors.textPrimary,
    textTransform: "capitalize",
  },

  statValueSuccessCapitalized: {
    fontWeight: "600",
    color: colors.success,
    textTransform: "capitalize",
  },

  healthStatusSmallChip: {
    textTransform: "capitalize",
    fontWeight: "600",
    fontSize: "0.75rem",
  },

  // Footer styles
  footer: {
    textAlign: "center",
    marginTop: "32px",
    padding: "24px 0",
    borderTop: `1px solid ${colors.borderLight}`,
    backgroundColor: colors.surface,
    borderRadius: "12px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },

  footerText: {
    display: "block",
    color: colors.textSecondary,
    fontWeight: "500",
    marginBottom: "4px",
    "&:last-child": {
      marginBottom: 0,
    },
  },

  // Responsive styles
  "@media (max-width:899.95px)": {
    batteryHealthRoot: {
      padding: "16px",
    },

    containerHeader: {
      flexDirection: "column",
      gap: "16px",
      alignItems: "stretch",
    },

    headerLeft: {
      justifyContent: "center",
    },

    periodSelector: {
      alignSelf: "stretch",
      
      "& .MuiButton-root": {
        flex: 1,
        fontSize: "0.875rem",
      },
    },

    vehicleInfoCard: {
      padding: "16px",
    },

    vehicleInfoContent: {
      flexDirection: "column",
      textAlign: "center",
      gap: "16px",
    },

    mainScoreContent: {
      padding: "16px 0",
    },

    mainScore: {
      fontSize: "3rem",
    },

    scoreCardContent: {
      padding: "16px",
    },

    statsCardContent: {
      padding: "16px",
    },

    footer: {
      padding: "16px 0",
    },
  },

  "@media (max-width:479.95px)": {
    batteryHealthRoot: {
      padding: "12px",
    },

    vehicleInfoCard: {
      padding: "12px",
    },

    vehicleName: {
      fontSize: "1.5rem",
    },

    mainScore: {
      fontSize: "2.5rem",
    },

    scoreCardContent: {
      padding: "12px",
    },

    statsCardContent: {
      padding: "12px",
    },

    noDataContainer: {
      padding: "20px 12px",
      minHeight: "100px",
    },

    noDataIcon: {
      fontSize: "36px",
    },
  },
});

export default useStyles;
